import { Component, OnInit, Injector, Input, OnChanges, NgModule, ElementRef } from '@angular/core';
import {  BaseComponent } from "../../base.component";

@Component({
selector: 'sep',
template: `
<hr class="separator">
`,
styleUrls: ['./sep.copmonent.scss']
})

export class SepComponent {

}